import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-arrow-left\">\n<path d=\"M95.1,109.776l48.918,48.918c5.401,5.401,5.401,14.159,0,19.56l0,0c-5.401,5.401-14.159,5.401-19.56,0L55.98,109.776\n\tc-5.399-5.399-5.399-14.152,0-19.551l68.478-68.478c5.401-5.401,14.159-5.401,19.56,0l0,0c5.401,5.401,5.401,14.159,0,19.56\n\tL95.1,90.224C89.701,95.623,89.701,104.377,95.1,109.776z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-left.svg
// module id = INtk
// module chunks = 3